import { DataModel } from "common/models/utility-models/base-model";

export class FeedbackStudentsPreviewModel extends DataModel {
    student_id: any = '';
    feedbackFormId: any = '';
    feedback_form_mapping_id: any = '';
    question_type: any = "";

}
